module.exports = __webpack_public_path__ + "media/images/referrals/trustpilot-logo-1aa2a76e76c7f9a716fe3d7af14c06f9.svg";